<template>
  <div v-if="currentTab">
    <div class="b-show-tab__container">
      <div class="b-show-tab__step-indicator">
        <div
          class="b-show-tab__step"
          :class="{approve: !tab.isReject,reject: tab.isReject,active : currentTab.name === tab.name }"
          v-for="tab in tabs"
          v-bind:key="tab.name"
          v-on:click="changeCurrentTabHandler(tab)"
        >
          <div>
            <h2>{{tab.name}}</h2>
            <div :class="{'b-show-container__active': currentTab.name === tab.name }"></div>
          </div>

          <div class="b-show-tab__step-icon">
            <div v-if="tab.isReject">
              <img
                class="b-show-tab__step-icon__close-icon"
                src="../../assets/Close-128.png"
                style="width:16px"
              />
            </div>
            <div v-else>
              <img class="b-show-tab__step-icon__check-mark" src="../../assets/check-mark.png" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="details && Object.keys(details).length !== 0">
      <h3 class="b-show-container-heading">CKYC for {{details.fullname}} ({{details.pan_number}})</h3>
        <!-- for cvl rejection only -->
        <!-- <div v-if="details.kyc_form_check_status == '6'" class="b-show__cvl-error-message">
          <div class="b-show__error-message--title">Error message by CVL: &nbsp; </div>
          <div>{{details.error_message}}</div>
        </div> -->
        <!-- for pending and rejected by admin -->
         <component
        v-bind:is="currentTabComponent"
        v-bind:checkDetails="currentTab.checkDetails"
        v-bind:details="details"
        v-bind:tabs="tabs"
        v-bind:editFlag="editFlag"
        @changeEditFlag="changeEditFlagHandler"
        @goNext="goNextHandler"
        @checkDetail="changeCheckDetailHandler"
        @changeApproveCheckMark="changeApproveCheckMarkHandler"
      ></component>
   
    
    </div>
    <div v-else>
      <div class="loader"></div>
    </div>
    <div v-if="showModal">
      <Modal
        @closeModal="showModal= false"
        @goNext="goNextHandler"
        @changeTabs="changeTabsHandler"
        @cancelChanges="isCancelChanges=true"
        v-bind:changeTab="changeTab"
      ></Modal>
    </div>
  </div>
</template>
<script>
import CKycPersonalDetails from "./CKycPersonalDetails.vue";
import CKycAddressDetails from "./CKycAddressDetails.vue";
import CKycApproveDetails from "./CkycApproveDetails.vue";
import CKycIPVDetails from "./CKycIPVDetails.vue";
import Modal from "../../commons/modal-ckyc.vue";
import { mapGetters,mapState } from "vuex";
export default {
  components: {
    CKycPersonalDetails,
    CKycAddressDetails,
    CKycApproveDetails,
    CKycIPVDetails,
    Modal
  },
  data() {
    return {
      currentTab: null,
      editFlag: false,
      showModal: false,
      changeTab: null,
      isReject: false,
      isCancelChanges: false,
      fromMask:null
      // tabs: [
      //   {
      //     name: "Personal",
      //     checkDetails: {
      //       pan_status: false,
      //       name: false,
      //       dob: false,
      //       signature: false
      //     },
      //     isReject: true
      //   },
      //   {
      //     name: "Address",
      //     checkDetails: { address_status: false },
      //     isReject: true
      //   },
      //   {
      //     name: "IPV",
      //     checkDetails: { gender: false, video: false },
      //     isReject: true
      //   },
      //   { name: "Approve", isReject: true }
      // ]
    };
  },
  
  async mounted() {
   await this.$nextTick()
    this.currentTab =  this.fromMask ? this.tabs[1]:this.tabs[0];
    this.$store.dispatch("ckycDetailsByID",{ id: this.$route.params.id}).then(() => {
      if ( ["update_pending", "upload_pending","uploaded","in_progress","active"].includes(this.details.status)) {
        this.tabs.map((_, index) => {
          // this.tabs[index].isReject = false;
          this.$store.commit("toggleRejectCkyc",{index,value:false});

        });
      }
    });
  },
  beforeRouteEnter (to, from, next) {
   next(vm => {
    // access to component instance via `vm`
    if(from.name){
      if((from.name!=='ckyc-details') && ((from.name==='ckyc-details-mask-img') || !(from.name==='ckyc-details-edit-img' && (from.params.imgname==='url_photo' || from.params.imgname==='url_poi_side1' || from.params.imgname==='file_signature'))))
       vm.fromMask = true
    }
   
  })
},

  methods: {
    goNextHandler: function() {
      let index = this.tabs.findIndex(
        element => element.name === this.currentTab.name
      );
      this.currentTab = this.tabs[index + 1];
      this.editFlag = false;
      this.showModal = false;
    },

    changeCheckDetailHandler: function(element) {
      let index = this.tabs.findIndex(e => e.name === this.currentTab.name);
      let toogle = this.tabs[index].checkDetails[element];
      // this.tabs[index].checkDetails[element] = !toogle;

      this.$store.commit("toggleCheckBoxCkyc",{index,element,value: !toogle});
      if (index == 1 && this.details.ckyc_identity_type != 'driving_license' && this.details.ckyc_identity_type != 'passport'){
        element = 'address_validity'
        this.$store.commit("toggleCheckBoxCkyc",{index,element,value: true});
      }
      this.validateInfo(index);
    },

    validateInfo(index) {
      let validate = true;
      Object.keys(this.currentTab.checkDetails).map(key => {
        if (this.currentTab.checkDetails[key] === false) {
          validate = false;
          return;
        }
      });
      if (validate) 
      // this.tabs[index].isReject = false;
      this.$store.commit("toggleRejectCkyc",{index,value:false});
      else 
      // this.tabs[index].isReject = true;
      this.$store.commit("toggleRejectCkyc",{index,value:true});
    },
    changeEditFlagHandler(value) {
      this.editFlag = value;
    },
    changeCurrentTabHandler(tab) {
      if (this.editFlag) {
        this.changeTab = { tab: tab, value: true };
        this.showModal = true;
      } else {
        this.currentTab = tab;
        this.showModal = false;
      }
    },
    changeTabsHandler(tab) {
      this.currentTab = tab;
      this.editFlag = false;
      this.showModal = false;
    },

    changeApproveCheckMarkHandler(value) {
      let index = this.tabs.length - 1;
      // this.tabs[this.tabs.length - 1].isReject = value;
      this.$store.commit("toggleRejectCkyc",{index,value});
    }
  },
  computed: {
    ...mapGetters(["getCkycDetails","getCKycStatusForApproval"]),
     ...mapState({
      tabs: state => state.ckycDetails.tabs,
    }),
    currentTabComponent: function() {
      return "CKyc" + this.currentTab.name + "Details";
    },
    details: function() {
      return this.getCkycDetails;
    }
  }
};
</script>

<style scoped>
.b-show-container {
  display: flex;
  justify-content: center;
  margin-top: 51px;
}
.b-show-container-heading {
  text-align: center;
  margin-top: 35px;
}
.b-show__cvl-error-message{
  display: flex;
  justify-content: center;
  margin-top: 35px;
}
.b-show__error-message--title{
  font-size: 18px;
  font-weight: 500px;
  color: #ef3189;

}
.b-show__admin-error-messages{
  display: flex;
  flex-direction: column;
  margin: unset;
}
.b-show__admin-error-messages li{
  padding: 6px;
}
.b-show-container__cursor {
  cursor: pointer;
  margin: 15px 40px;
}
.b-show-container h2 {
  text-align: center;
  margin-bottom: unset;
}

.b-show-container__disable {
  pointer-events: none;
  opacity: 0.6;
  filter: alpha(opacity = 60);
}
.b-show-container__active {
  border: solid 1.5px #2b3d51;
}
.b-show-tab__container {
  display: flex;
  justify-content: center;
}
.b-show-tab__step-indicator {
  margin-top: 80px;
  display: flex;
  align-items: center;
  padding: 0 40px;
  width: 1164px;
  justify-content: space-between;
}
.b-show-tab__step {
  display: flex;
  cursor: pointer;
}

.b-show-tab__step h2 {
  margin: unset;
}
.b-show-tab__step-icon {
  height: 20px;
  width: 20px;
  border-radius: 50%;
  background: #c2c2c2;
  font-size: 10px;
  text-align: center;
  color: #ffffff;
  position: relative;
  margin: 5px 10px;
}
.b-show-tab__indicator-line {
  width: 100%;
  height: 2px;
  background: #c2c2c2;
  flex: 1;
}
/* .b-show-tab__step.active .b-show-tab__step-icon {
  background: #1890ff;
    border: none;
} */
.b-show-tab__step.reject .b-show-tab__step-icon {
  background-color: #f5222d;
}
/* .b-show-tab__step.reject p {
  color: #f5222d;
} */
.b-show-tab__step.approve .b-show-tab__step-icon {
  background-color: #008000;
}
/* .b-show-tab__step.approve p {
  color: #008000;
} */
.b-show-tab__step-icon-text {
  color: #000000;
}

/* .b-show-tab__step.active p {
  color: #1890ff;
} */
.b-show-tab__step-icon__check-mark {
  padding-top: 2px;
  width: 12px;
  height: 13px;
}
.b-show-tab__step-icon__close-icon {
  width: 16px;
  height: 16px;
  padding-top: 2px;
}
</style>

